// Possible rules that can be applied to a control.
const rules = {
  required: {
    required: 'Field is required.',
  },
  alpha: {
    pattern: {
      value: /^[A-Za-z'][A-Za-z'\s]{1,30}$/,
      message: 'Field is invalid.',
    },
  },
  number: {
    pattern: {
      value: /^[1-9'][0-9']{0,2}$/,
      message: 'Field is invalid.',
    },
  },
};

/**
 * Build a rules object for a control
 * @param {array} names
 * @param {object} state
 * @returns {object}
 */
const useRules = (names, state) => {
  let generated = {};

  if (Array.isArray(names) && names.length > 0) {
    names.forEach((name) => {
      if (typeof name === 'string') {
        generated = { ...generated, ...rules[name] };
      } else if (typeof name === 'object') {
        Object.keys(name).forEach((key) => {
          let rule = name[key];

          // Wrap the validator and inject the state.
          if (typeof name[key] === 'function') {
            rule = (v) => name[key](v, state);
          }

          generated = { ...generated, [key]: rule };
        });
      }
    });
  }

  return generated;
};

export { useRules, rules };
